import { Box, Container, Grid, Paper, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { format, subDays } from 'date-fns'
import isEmpty from 'lodash/isEmpty'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ComingSoon from '../components/coming-soon/ComingSoon'
import OrderStatusSidebar from '../components/common/OrderStatusSidebar'
import Delivery from '../components/home/Delivery'
import FeedbackLink from '../components/home/FeedbackLink'
import NoDeliveriesToday from '../components/home/NoDeliveriesToday'
import SubscriptionPromotional from '../components/home/SubscriptionPromotional'
import { YourLocation } from '../components/home/YourLocation'
import {
  loadDeliveryScheduleFailure,
  loadDeliveryScheduleStart,
  selectDelivery,
} from '../redux/modules/delivery'
import { addFavoritesForMenusStart, getFavoritesForMenusCount } from '../redux/modules/favorite'
import { changeSelectedDay } from '../redux/modules/home'
import { loadLocationStart } from '../redux/modules/location'
import { loadOrderStart } from '../redux/modules/orderDetail'
import { loadProfileStart } from '../redux/modules/profile'
import {
  isSelectedDeliveryDateActive,
  selectCurrentLocationWithAddress,
} from '../redux/modules/selectors'
import { confirmPasswordStart } from '../redux/modules/user'
import { getDayName } from '../util/dateUtils'
import { pushAnalyticsEvent } from '../util/gtmUtils'
import {
  pushSnowplow,
  toDeliveryEntities,
  toOrderEntities,
  toOrderProcessSchema,
} from '../util/snowplow'

const LoadDayError = () => (
  <div className="center-xs">
    <h5 className="error center-xs">
      <i className="icon-warning" /> Oops! Something went wrong.
    </h5>
    <p>
      Try refreshing the page or switching between days. If this problem persists, please{' '}
      <a href={`/contact`}>contact support</a>
    </p>
  </div>
)

class Home extends Component {
  componentDidMount() {
    const {
      match: {
        params: { locationId },
      },
    } = this.props
    const { isAuthenticated, loadLocationStart } = this.props
    loadLocationStart(locationId)
    this.fetchDeliveries(locationId)
    if (isAuthenticated) {
      this.fetchPageData(locationId)
    }
    pushAnalyticsEvent('Ordering', 'View Deliveries', undefined, locationId)
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated, loadLocationStart } = this.props
    let {
      deliveryError,
      match: {
        params: { locationId = 0 },
      },
    } = this.props
    locationId = Number(locationId)
    if (Number(prevProps.match.params.locationId) !== locationId) {
      loadLocationStart(locationId)
      this.fetchDeliveries(locationId)
      this.fetchPageData(locationId, true)
    }
    if (prevProps.isAuthenticated === false && isAuthenticated === true) {
      this.fetchPageData(locationId)
    }
    if (deliveryError) {
      pushSnowplow(toOrderProcessSchema('daily', 'deliveries_view', null, deliveryError))
    }
    if (this.props.deliveries && this.props.deliveries !== prevProps.deliveries) {
      this.fetchFavoritesForMenus()
      this.pushSnowplowEvent()
    }
  }

  pushSnowplowEvent = () => {
    const { deliveries, orders, selectedDate } = this.props
    const localEntities = isEmpty(orders)
      ? toDeliveryEntities(deliveries)
      : [...toDeliveryEntities(deliveries), ...toOrderEntities(orders)]
    const onDate = format(subDays(selectedDate, 0), 'YYYY-MM-DD')

    pushSnowplow(toOrderProcessSchema('daily', 'deliveries_view', onDate, null), localEntities)
  }

  fetchDeliveries = locationId => {
    const { loadDeliveryScheduleStart, selectedDate } = this.props
    loadDeliveryScheduleStart(locationId, selectedDate)
  }

  fetchFavoritesForMenus = async () => {
    const { addFavoritesForMenusStart, deliveries, isAuthenticated } = this.props
    const menuIds = deliveries.map(d => d.menuId)
    if (menuIds.length > 0 && isAuthenticated) {
      const result = await getFavoritesForMenusCount(menuIds)
      addFavoritesForMenusStart(result)
    }
  }

  fetchPageData = currentLocationId => {
    const { isAuthenticated, loadOrderStart, selectedDate } = this.props
    const locationId = currentLocationId || Number(this.props.match.params.locationId)
    if (isAuthenticated) {
      loadOrderStart(selectedDate, locationId)
    }
  }

  passwordVisibility() {
    let currentType = document.getElementById('loginPassword')
    currentType.type === 'password' ? (currentType.type = 'text') : (currentType.type = 'password')
  }

  render() {
    const {
      activationDate,
      changeSelectedDay,
      deliveries,
      deliveryError,
      isAuthenticated,
      isLoadingDeliveries,
      isSelectedDayActive,
      isWebpSupported,
      loadingNewDay,
      location,
      orders,
      selectedDate,
    } = this.props
    let {
      friendHasOrdered,
      match: {
        params: { locationId },
      },
    } = this.props
    locationId = Number(locationId)
    const hasOrders = orders && orders.length > 0

    return (
      <Box
        py={4}
        style={{
          backgroundColor: '#f5f5f5',
          minHeight: 'calc(100vh - 287px)',
        }}
      >
        {loadingNewDay || isLoadingDeliveries ? (
          <div>
            <SkeletonLoadingDate logoShape="circle" />
            <SkeletonLoadingCard />
            <SkeletonLoadingCard logoShape="circle" />
            <SkeletonLoadingCard logoShape="circle" />
            <SkeletonLoadingCard />
            <SkeletonLoadingCard />
          </div>
        ) : (
          <>
            <Container maxWidth="lg">
              <Grid container justify="center">
                <Grid item md={8} xs={12}>
                  <Box marginBottom={3}>
                    <YourLocation
                      name={location?.deliveryLocationName}
                      orderCount={orders?.length}
                      selectedDate={selectedDate}
                    />
                    {/* Show subscriptions promo banner if a user has not ordered and isn't a new building*/}
                    {!hasOrders && isSelectedDayActive && deliveries?.length > 0 && (
                      <SubscriptionPromotional />
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Container>
            {/* Show manage order card */}
            {hasOrders && (
              <Box marginBottom="48px">
                <Paper square variant="outlined">
                  <Box paddingY={4}>
                    <Container className="container">
                      <Grid container justify="center">
                        <Grid item md={8} xs={12}>
                          <div className="statusContainer">
                            <OrderStatusSidebar locationId={locationId} />
                          </div>
                        </Grid>
                      </Grid>
                    </Container>
                  </Box>
                </Paper>
              </Box>
            )}
            <Container className="container ContainerGutters">
              <Grid container justify="center">
                <Grid item md={8} xs={12}>
                  <>
                    {deliveryError && <LoadDayError />}
                    {/* If location had deliveries show delivery cards*/}
                    {deliveries && deliveries.length && (
                      <>
                        {hasOrders && (
                          <Typography component="h2" gutterBottom variant="h6">
                            More options delivering {getDayName(selectedDate)}
                          </Typography>
                        )}
                        <Delivery
                          deliveries={deliveries}
                          friendHasOrdered={friendHasOrdered}
                          isSelectedDayActive={isSelectedDayActive}
                          isWebpSupported={isWebpSupported}
                          locationId={locationId}
                          selectDelivery={selectDelivery}
                          selectedDate={selectedDate}
                        />
                      </>
                    )}
                    {/* If location has no deliveries and is not a new building show no deliveries component */}
                    {!deliveries && !deliveries?.length && isSelectedDayActive && (
                      <NoDeliveriesToday selectedDate={selectedDate} />
                    )}
                  </>

                  {/* Load coming soon content for new buildings */}
                  {!isSelectedDayActive && activationDate && (
                    <ComingSoon
                      activationDate={activationDate}
                      isAuthenticated={isAuthenticated}
                      locationId={locationId}
                      onChangeDay={date => changeSelectedDay(date, locationId)}
                    />
                  )}
                  <Box className="center-xs" marginTop={4}>
                    <FeedbackLink />
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </>
        )}
      </Box>
    )
  }
}

const SkeletonLoadingCard = ({ logoShape }) => {
  return (
    <Box marginBottom={3}>
      <Container maxWidth="lg">
        <Grid container justify="center">
          <Grid item md={8} xs={12}>
            <Paper variant="outlined">
              <Box alignItems="center" display="flex" minHeight="200px">
                <Grid alignItems="center" container justify="center">
                  <Grid item md={5} xs={12}>
                    <Box display="flex" justifyContent="center">
                      <Skeleton height={150} variant={logoShape} width={150} />
                    </Box>
                  </Grid>
                  <Grid item md={5} xs={12}>
                    <Skeleton height={50} />
                    <Grid container justify="flex-start">
                      <Grid item xs={5}>
                        <Skeleton height={15} width={80} />
                        <Skeleton height={40} width={100} />
                      </Grid>
                      <Grid item xs={2}>
                        <Skeleton height="100%" width={3} />
                      </Grid>
                      <Grid item xs={5}>
                        <Skeleton height={15} width={80} />
                        <Skeleton height={40} width={100} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const SkeletonLoadingDate = () => {
  return (
    <Box marginBottom={3} marginTop={2}>
      <Container maxWidth="lg">
        <Grid container justify="center">
          <Grid item md={8} xs={12}>
            <Box display="flex" justifyContent="space-between">
              <Skeleton height={25} width={100} />
              <Skeleton height={20} width={250} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const mapStateToProps = state => {
  const { deliveries, isLoadingDeliveries } = state.delivery
  const deliveryError = state.delivery.error
  const { loadingNewDay, selectedDate } = state.home
  const { isAuthenticated } = state.user
  const location = selectCurrentLocationWithAddress(state)
  const { location: { activationDate } = {} } = state.location
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { loading, orders } = state.orderDetail
  const { isWebpSupported } = state.browser
  return {
    activationDate,
    deliveries,
    deliveryError,
    isAuthenticated,
    isLoadingDeliveries,
    isOrdersLoading: loading,
    isSelectedDayActive,
    isWebpSupported,
    loadingNewDay,
    location,
    orders,
    selectedDate,
  }
}

const mapDispatchToProps = {
  addFavoritesForMenusStart,
  changeSelectedDay,
  confirmPasswordStart,
  loadDeliveryScheduleFailure,
  loadDeliveryScheduleStart,
  loadLocationStart,
  loadOrderStart,
  loadProfileStart,
  selectDelivery,
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
